"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8520],{

/***/ 18520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ NavLinks_NavLinks; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(26628);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(75681);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./i18n/index.ts
var i18n = __webpack_require__(54407);
;// CONCATENATED MODULE: ./components/header/NavLinks/handleMouseEnter.tsx

var handleMouseEnter = function(event, locale) {
    var direction = i18n/* default */.Z[locale].direction;
    var item = event.currentTarget;
    var megaMenu = item.querySelector(".nav-links__megaMenu");
    if (megaMenu) {
        var container = megaMenu.offsetParent;
        var containerWidth = (container === null || container === void 0 ? void 0 : container.getBoundingClientRect().width) || 0;
        var megaMenuWidth = megaMenu.getBoundingClientRect().width;
        var itemOffsetLeft = item.offsetLeft;
        if (direction === "rtl") {
            var itemPosition = containerWidth - (itemOffsetLeft + item.getBoundingClientRect().width);
            var megaMenuPosition = Math.round(Math.min(itemPosition, containerWidth - megaMenuWidth));
            megaMenu.style.left = "";
            megaMenu.style.right = "".concat(megaMenuPosition, "px");
            return;
        }
        var megaMenuPosition1 = Math.round(Math.min(itemOffsetLeft, containerWidth - megaMenuWidth));
        megaMenu.style.right = "";
        megaMenu.style.left = "".concat(megaMenuPosition1, "px");
    }
};
/* harmony default export */ var NavLinks_handleMouseEnter = (handleMouseEnter);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/header/header.module.scss
var header_module = __webpack_require__(44032);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
;// CONCATENATED MODULE: ./components/header/NavLinks/LinksList.tsx








var NavMenu = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8017).then(__webpack_require__.bind(__webpack_require__, 78017));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78017)
            ];
        }
    }
});
var LinksList = function(param) {
    var schemaLinks = param.schemaLinks, classes = param.classes, locale = param.locale, item = param.item, realPath = param.realPath, hasChildren = param.hasChildren;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(schemaLinks)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: classes,
                onMouseEnter: function(event) {
                    return NavLinks_handleMouseEnter(event, locale);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.url_key || item.slug && "/".concat(realPath, "page/").concat(item.slug) || "",
                        prefetch: false,
                        children: item.new_tab ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            target: "_blank",
                            children: [
                                item.name,
                                hasChildren && /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown9x6Svg */.jN, {})
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                item.name,
                                hasChildren && /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown9x6Svg */.jN, {})
                            ]
                        })
                    }),
                    hasChildren && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((header_module_default())["nav-links__menu"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMenu, {
                            items: item.children,
                            realPath: realPath
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var NavLinks_LinksList = (LinksList);

// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
;// CONCATENATED MODULE: ./components/schemaorg/index.tsx

var schemaNavLinks = function(dbName, asPath, menuList) {
    return {
        "@context": "https://schema.org/",
        "@type": "Menu",
        url: (0,helper/* domainUrl */.HJ)(dbName + asPath),
        "name": "MenuItems",
        "description": "Company menu items description",
        "hasMenuSection": menuList.map(function(item, index) {
            return {
                "@type": "MenuSection",
                "position": index + 1,
                "hasMenuItem": {
                    "@type": "MenuItem",
                    "name": item === null || item === void 0 ? void 0 : item.name
                }
            };
        })
    };
};

;// CONCATENATED MODULE: ./components/header/NavLinks/NavLinks.tsx











function NavLinks(param) {
    var pageProps = param.pageProps;
    var ref;
    var router = (0,next_router.useRouter)();
    var menuList = (0,es/* useSelector */.v9)(function(state) {
        return state.general.menuList;
    });
    var locale = (0,es/* useSelector */.v9)(function(state) {
        return state.locale.code;
    });
    var realPath = router.locale !== "catchAll" ? router.locale + "/" : "";
    var hasBlog = Boolean(+(0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.general.coreConfigs.theme_blog_active) === null || ref === void 0 ? void 0 : ref.value;
    }));
    var schemaLinks = schemaNavLinks(pageProps === null || pageProps === void 0 ? void 0 : pageProps.dbName, router.asPath, menuList);
    var navLinks = router.asPath === "/" ? pageProps === null || pageProps === void 0 ? void 0 : pageProps.menus : menuList;
    var linksList = (ref = navLinks === null || navLinks === void 0 ? void 0 : navLinks.filter(function(item) {
        return item.type === "header";
    })) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
        var hasChildren = item.children && item.children.length > 0;
        var classes = classnames_default()((header_module_default())["nav-links__item"], hasChildren && (header_module_default())["nav-links__item--with-submenu"]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLinks_LinksList, {
            schemaLinks: schemaLinks,
            realPath: realPath,
            classes: classes,
            locale: locale,
            item: item,
            hasChildren: hasChildren
        }, index);
    });
    var showBlog = (pageProps === null || pageProps === void 0 ? void 0 : pageProps.isBlogActive) && router.asPath === "/" || router.asPath !== "/" && hasBlog;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "".concat((header_module_default())["nav-links__list"]),
        children: [
            linksList,
            showBlog && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (header_module_default())["nav-links__item"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: (0,utils/* rightUrl */.Ab)("/blog", router),
                    prefetch: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "blog",
                            defaultMessage: "Blog"
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var NavLinks_NavLinks = (NavLinks);


/***/ }),

/***/ 54407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// application
var enMessages = __webpack_require__(82742);
var ruMessages = __webpack_require__(16495);
var hyMessages = __webpack_require__(24447);
/* harmony default export */ __webpack_exports__["Z"] = ({
    en: {
        messages: enMessages,
        direction: "ltr"
    },
    ru: {
        messages: ruMessages,
        direction: "ltr"
    },
    hy: {
        messages: hyMessages,
        direction: "ltr"
    }
});


/***/ }),

/***/ 82742:
/***/ (function(module) {

module.exports = {};

/***/ }),

/***/ 24447:
/***/ (function(module) {

module.exports = {};

/***/ }),

/***/ 16495:
/***/ (function(module) {

module.exports = JSON.parse('{"topBar.phone1":"374 93 99-10-93","topBar.phone2":"+374 10 35-11-00","topBar.storeLocation":"Магазин","topBar.trackOrder":"Статус заказа","topBar.blog":"Блог","topBar.myAccount":"Аккаунт","topBar.currency":"Валюта","topBar.language":"Язык","topBar.login":"Մուտք","topBar.forgot":"Մոռացե՞լ եք գաղտնաբառը","header.phoneLabel":"Звонок бесплатный","header.phone":"(800) 060-0730"}');

/***/ })

}]);